import script from "./KakaoLoginButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./KakaoLoginButton.vue?vue&type=script&setup=true&lang=ts"

import "./KakaoLoginButton.scss?vue&type=style&index=0&lang=scss&external"

const __exports__ = script;

export default __exports__